import axiosGraphQL from './GraphQL/axiosGraphQL';
import { GET_ALL_MARKET_GOLD_PRICE_QUERY } from './GraphQL/Queries/goldPrice';
import {
  IGetAllGoldPrice,
  MARKET_GOLD_PRICE_VARIABLES,
} from './GraphQL/Variables/goldPrice';

export const MarketGoldPriceApis = {
  getAll: async (params: IGetAllGoldPrice) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_ALL_MARKET_GOLD_PRICE_QUERY,
      variables: MARKET_GOLD_PRICE_VARIABLES.getAll(params),
    });
  },
};
